// frontend/src/pages/OAuthRedirectHandler.js
import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useAnalytics } from "../hooks/useAnalytics";

const OAuthRedirectHandler = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { trackLogin, trackProfileLinked, trackLoginFailed } = useAnalytics();

  useEffect(() => {
    const access = searchParams.get("access");
    const refresh = searchParams.get("refresh");
    const faculty_id = searchParams.get("faculty_id");
    // Get the redirect parameter or default to home
    const redirectPath = searchParams.get("redirect") || "/home";
    
    if (access && refresh) {
      // Store tokens in localStorage
      localStorage.setItem("access", access);
      localStorage.setItem("refresh", refresh);
      
      // Track successful login
      trackLogin();
      
      if (faculty_id) {
        localStorage.setItem("faculty_id", faculty_id);
        
        // Track profile linking if this is the first time
        const isNewLink = searchParams.get("profile_linked") === "true";
        if (isNewLink) {
          trackProfileLinked();
        }
      }
      
      // Add a small delay to ensure tokens are properly stored before navigating
      setTimeout(() => {
        navigate(redirectPath, { replace: true });
      }, 100);
    } else {
      // If tokens are missing, track login failure and redirect to login
      trackLoginFailed();
      navigate("/login", { replace: true });
    }
  }, [searchParams, navigate, trackLogin, trackProfileLinked, trackLoginFailed]);

  // Show a loading indicator while processing
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <div>Processing login...</div>
    </div>
  );
};

export default OAuthRedirectHandler;
